module.exports = __webpack_public_path__ + "img/img-3-3mobile.aed5e566.webp";